import React from 'react';
import { Button, typographyStyles, spacing } from '@livecommerce/design-system';
import { m } from 'framer-motion';
import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import { mainTransitionConfig } from 'constants/animationConfig.js';

const notificationWrapperStyles = css`
  background: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04), 0 0 1px rgba(0, 0, 0, 0.04), 0 16px 24px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  padding: 24px 40px;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  align-items: center;
`;

const TextWrapper = styled.div`
  padding-right: ${spacing(24)};
`;

const Title = styled.h2`
  ${typographyStyles.getMediumHeadline()}
  margin: 0;
`;

const Text = styled.p`
  ${typographyStyles.getBodyText(12)}
  margin: 0;
  margin-top: ${spacing(8)};
`;

const FirstButton = styled(Button)`
  margin-right: ${spacing(8)};
`;

const Notification = ({ cancel }) => {
  const { t } = useLocalization();
  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <m.div
      className={notificationWrapperStyles}
      initial={{ x: '-50%', y: 0 }}
      animate={{ x: '-50%', y: -32 }}
      transition={mainTransitionConfig}
    >
      <TextWrapper>
        <Title>{t('newVersionNotification.title')}</Title>
        <Text>{t('newVersionNotification.text')}</Text>
      </TextWrapper>
      <FirstButton variant="primary" onClick={reloadPage}>{t('newVersionNotification.button')}</FirstButton>
      <Button variant="regular" onClick={cancel}>{t('newVersionNotification.dismiss')}</Button>
    </m.div>
  );
};

export default Notification;
